import fr from './fr.json';
import de from './de.json';
import en from './en.json';

export default {
  fr,
  de,
  en,
};